export const RETELL = {
  publicKey: 'public_key_ce7f4b574cbe7bcc5ce60',
  chargeLabAgentId: 'agent_ee69543e783fde522ffcaae049',
  filgoFrenchAgentId: 'agent_be1da9ccfa22ea90af38b48fa4',
  filgoEnglishAgentId: 'agent_ee69543e783fde522ffcaae049', // no filgo english?
  ivyFrenchAgentId: 'agent_8bc0a247c707873db08c1f7591',
  ivyEnglishAgentId: 'agent_f6058ae8c18eb7c93d8c66c2b8',
  phoneNumber: '+12294084029',
  countries: 'US,CA',
};
